var dd = require('react-dd');
var _ = require('lodash');
var esUtils = require('../utils/esUtils');

require('./Aside.less.js');

var VerticalScroll = require('./VerticalScroll');

module.exports = dd.createClass({
	__onClose: esUtils.wrapPreventDefault(function(){
		if(_.isFunction(this.props.__onClose)){
			this.props.__onClose();
		}
	}),
	render: function(){

		return dd.div({className: 'Aside ' + (this.props.className ? this.props.className : '')},
			dd.div({className: 'aside ' + (this.props.right ? 'right' : 'left'), tabIndex: -1, role: 'dialog'},
				dd.div({className: 'aside-dialog'},
					dd.div({className: 'aside-content'},
						dd.table({style: {width: '100%', height: '100%', border: 0, margin: 0, padding: 0}},
							dd.tbody(null,
								dd.tr({style: {width: '100%', border: 0, margin: 0, padding: 0}},
									dd.td({style: {width: '100%', height: '1px', border: 0, margin: 0, padding: 0}},
										dd.div({className: 'aside-header'},
											dd.a({className: 'close', href: '#', onClick: this.__onClose}, 'CLOSE'),
											this.props.header
										)
									)
								),
								dd.tr({style: {width: '100%', border: 0, margin: 0, padding: 0}},
									dd.td({style: {width: '100%', height: '100%', verticalAlign: 'top', border: 0, margin: 0, padding: 0}},
										VerticalScroll(null,
											dd.div({className: 'aside-body'},
												this.props.children
											)
										)
									)
								)
							)
						)
					)
				)
			),
			dd.div({className: 'aside-backdrop in', onClick: this.__onClose})
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/Aside.js
// module id = 178
// module chunks = 0 1 2 3 4